import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate13: LandingPageConfigOptions = {
  consentAge: 19,
  ...USALandingOptions,
};
